import {Iterable} from 'immutable';

// Passed in as reviver argument for fromJS
function asOrderedMap(key, value) {
  return Iterable.isKeyed(value) ? value.toOrderedMap() : value.toList();
}

export {asOrderedMap};
